"use strict";

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePromiseRef = exports.useCloseableAsync = exports.useCloseable = exports.defaultClose = void 0;

var _react = require("react");
/** utility hooks. */


var defaultClose = function defaultClose(value) {
  return 'close' in value ? value.close() : 'destroy' in value ? value.destroy() : 'remove' in value ? value.remove() : undefined;
};

exports.defaultClose = defaultClose;

var useCloseable = function useCloseable(supplier) {
  var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultClose;
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var state = (0, _react.useMemo)(supplier, []);
  (0, _react.useEffect)(function () {
    return function () {
      return close(state);
    };
  }, deps);
  return state;
};

exports.useCloseable = useCloseable;

var useCloseableAsync = function useCloseableAsync(supplier) {
  var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultClose;
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var closeRef = (0, _react.useRef)(false);

  var _ref = (0, _react.useState)(undefined),
      _ref2 = _slicedToArray(_ref, 2),
      state = _ref2[0],
      setState = _ref2[1];

  (0, _react.useEffect)(function () {
    var promise = Promise.resolve(supplier(closeRef));
    closeRef.current || promise.then(setState);
    return function () {
      closeRef.current = true;
      promise.then(close);
    };
  }, deps);
  return state;
}; // deprected.
// export const useUpdate: typeof useEffect = (
//   update: EffectCallback,
//   deps: DependencyList = []
// ): void => {
//   useMemo(update, []);
//   useEffect(update, deps);
// };


exports.useCloseableAsync = useCloseableAsync;

var usePromiseRef = function usePromiseRef() {
  return (0, _react.useMemo)(function () {
    var value = null;
    var setValue;
    var promise = new Promise(function (resolve) {
      return setValue = resolve;
    });
    return {
      set current(instance) {
        value = instance;
        instance == null || setValue(instance);
      },

      get current() {
        return value;
      },

      then: promise.then.bind(promise)
    };
  }, []);
};

exports.usePromiseRef = usePromiseRef;